<!-- 文件已废弃， 已经兼容到羽毛球中 schedule_match_list中 -->

<template>
  <div
    class="schedule_match_list"
    :class="[themeClass === 'onlyDisplay' ? 'onlyDisplay' : '', viewMode]"
  >
    <div
      class="match_list_item"
      :class="[chooseState, item.isChooseFlag ? 'chooseAct' : '']"
      v-for="item in data"
      :key="item.matchId"
      @click="goDetail(item)"
    >
      <span class="item_matchLeft">
        <span class="matchLeft_colum1">
          <span
            v-if="themeClass === 'onlyDisplay'"
            class="matchLeft_colum1_row1"
            v-text="
              _valPerFormatHandler(
                `${item.formatDate ? item.formatDate : ''} ${item.matchTime}`
              )
            "
          ></span>
          <span
            v-else
            class="matchLeft_colum1_row1"
            v-text="_valPerFormatHandler(item.matchTime)"
          ></span>
          <span class="matchLeft_colum1_row2">
            <span class="national_icon" v-if="item.isChina"></span>
            <span class="medal_icon" v-if="item.isGold"></span>
          </span>
        </span>
        <span class="matchLeft_colum2">
          <span
            class="matchLeft_colum2_row1"
            v-text="_valPerFormatHandler(item.matchName)"
          ></span>
          <span class="matchLeft_colum2_row2">
            <span class="sportHall_icon"></span>
            <span
              class="sportHall_name"
              v-text="_valPerFormatHandler(item.venueName)"
            ></span>
          </span>
        </span>
      </span>
      <span class="item_matchCenter" :class="item.type">
        <template v-if="item.type === sportsTypeArr[0]">
          <span class="matchCenter_colum1">
            <span class="matchCenter_colum1_row">
              <span class="delegationLogo">
                <img :src="item.homeLogo" />
              </span>
              <span
                class="delegationName"
                v-text="_valPerFormatHandler(item.homeName)"
              ></span>
            </span>
            <span class="matchCenter_colum1_row">
              <span class="delegationLogo">
                <img :src="item.awayLogo" />
              </span>
              <span
                class="delegationName"
                v-text="_valPerFormatHandler(item.awayName)"
              ></span>
            </span>
          </span>
          <span class="matchCenter_colum2">
            <span class="matchCenter_colum2_row" v-text="item.homeScore"></span>
            <span class="matchCenter_colum2_row" v-text="item.awayScore"></span>
          </span>
        </template>
        <template v-else>
          <span
            class="matchCenter_colum1"
            v-if="item.medalist && item.medalist.length > 0"
          >
            <span
              class="matchCenter_colum1_row"
              v-for="ceil in item.medalist"
              :key="ceil.playerId"
            >
              <span class="delegationLogo">
                <img :src="ceil.delegationLogo" />
              </span>
              <span
                v-if="ceil.mcompetitorType === 'A'"
                class="delegationName"
                v-text="_valPerFormatHandler(ceil.playerName)"
              ></span>
              <span
                v-if="ceil.mcompetitorType === 'T'"
                class="delegationName"
                v-text="_valPerFormatHandler(ceil.delegationName)"
              ></span>
            </span>
          </span>
          <span class="matchCenter_colum2">
            <span
              v-for="ceil in item.medalist"
              :key="ceil.playerId"
              class="matchCenter_colum2_row"
            >
              <span class="medalIcon" :class="ceil.medalType"></span>
            </span>
          </span>
        </template>
      </span>
      <span class="item_matchRight">
        <span
          class="matchRight_status"
          :class="
            matchStatusColorArr[matchStatusObj[item.matchStatus]].colorClass
          "
          v-text="matchStatusToMatchCN(item.matchStatus)"
        ></span>
      </span>
      <span class="item_absChoose" v-show="chooseState === 'choose'">
        <span class="checkbox_item">
          <svg
            t="1693726421166"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="21127"
            width="80%"
            height="80%"
          >
            <path
              d="M892.064 261.888a31.936 31.936 0 0 0-45.216 1.472L421.664 717.248l-220.448-185.216a32 32 0 1 0-41.152 48.992l243.648 204.704a31.872 31.872 0 0 0 20.576 7.488 31.808 31.808 0 0 0 23.36-10.112L893.536 307.136a32 32 0 0 0-1.472-45.248z"
              p-id="21128"
            ></path>
          </svg>
        </span>
      </span>
    </div>
  </div>
</template>

<script>
import cup_base_data_mixin from '@mixins/cup_base_data'
export default {
  name: 'schedule_match_list',
  mixins: [cup_base_data_mixin],
  props: {
    data: {
      type: Array,
      default: () => {
        return []
        // return [
        //   {
        //     matchId: 1,
        //     matchName: '篮球·男子预赛A组',
        //     type: 'combat', //对抗类或非对抗类
        //     isChina: true,
        //     isGold: false,
        //     medalist: [
        //       {
        //         playerId: '1',
        //         playerName: '张三',
        //         medalType: 'GOLD',
        //         delegationName: '中国',
        //         delegationLogo: '',
        //       },
        //       {
        //         playerId: '2',
        //         playerName: '张三',
        //         medalType: 'GOLD',
        //         delegationName: '中国',
        //         delegationLogo: '',
        //       },
        //       {
        //         playerId: '3',
        //         playerName: '张三',
        //         medalType: 'GOLD',
        //         delegationName: '中国',
        //         delegationLogo: '',
        //       },
        //     ],
        //     disciplineName: '艺术体操',
        //     disciplineId: 'GRY',
        //     matchStatus: 'Playing',
        //     matchTime: '12:30',
        //     venueName: '场馆名称场馆名称1',
        //     homeName: '主队',
        //     homeLogo: '',
        //     homeScore: 3,
        //     awayName: '客队',
        //     awayLogo: '',
        //     awayScore: 2,
        //   },
        //   {
        //     matchId: 2,
        //     matchName:
        //       '篮球·男子预赛A组篮球·男子预赛A组篮球·男子预赛A组篮球·男子预赛A组',
        //     type: 'uncombat', //对抗类或非对抗类
        //     isChina: true,
        //     isGold: true,
        //     medalist: [
        //       {
        //         playerId: '1',
        //         playerName: '张三',
        //         medalType: 'GOLD',
        //         delegationName: '中国',
        //         delegationLogo: '',
        //       },
        //       {
        //         playerId: '2',
        //         playerName: '张三',
        //         medalType: 'GOLD',
        //         delegationName: '中国',
        //         delegationLogo: '',
        //       },
        //       {
        //         playerId: '3',
        //         playerName: '张三',
        //         medalType: 'GOLD',
        //         delegationName: '中国',
        //         delegationLogo: '',
        //       },
        //     ],
        //     disciplineName: '艺术体操',
        //     disciplineId: 'GRY',
        //     matchStatus: 'Played',
        //     matchTime: '12:30',
        //     venueName: '场馆名称场馆名称1',
        //     homeName: '主队',
        //     homeLogo: '',
        //     homeScore: 3,
        //     awayName: '客队',
        //     awayLogo: '',
        //     awayScore: 2,
        //   },
        //   {
        //     matchId: 3,
        //     matchName:
        //       '篮球·男子预赛A组篮球·男子预赛A组篮球·男子预赛A组篮球·男子预赛A组',
        //     type: 'uncombat', //对抗类或非对抗类
        //     isChina: true,
        //     isGold: true,
        //     medalist: [
        //       {
        //         playerId: '1',
        //         playerName: '张三',
        //         medalType: 'GOLD',
        //         delegationName: '中国',
        //         delegationLogo: '',
        //       },
        //       {
        //         playerId: '2',
        //         playerName: '张三',
        //         medalType: 'GOLD',
        //         delegationName: '中国',
        //         delegationLogo: '',
        //       },
        //       {
        //         playerId: '3',
        //         playerName: '张三',
        //         medalType: 'GOLD',
        //         delegationName: '中国',
        //         delegationLogo: '',
        //       },
        //     ],
        //     disciplineName: '艺术体操',
        //     disciplineId: 'GRY',
        //     matchStatus: 'Played',
        //     matchTime: '12:30',
        //     venueName: '场馆名称场馆名称1',
        //     homeName: '主队',
        //     homeLogo: '',
        //     homeScore: 3,
        //     awayName: '客队',
        //     awayLogo: '',
        //     awayScore: 2,
        //   },
        //   {
        //     matchId: 4,
        //     matchName:
        //       '篮球·男子预赛A组篮球·男子预赛A组篮球·男子预赛A组篮球·男子预赛A组',
        //     type: 'uncombat', //对抗类或非对抗类
        //     isChina: true,
        //     isGold: true,
        //     medalist: [
        //       {
        //         playerId: '1',
        //         playerName: '张三',
        //         medalType: 'GOLD',
        //         delegationName: '中国',
        //         delegationLogo: '',
        //       },
        //       {
        //         playerId: '2',
        //         playerName: '张三',
        //         medalType: 'GOLD',
        //         delegationName: '中国',
        //         delegationLogo: '',
        //       },
        //       {
        //         playerId: '3',
        //         playerName: '张三',
        //         medalType: 'GOLD',
        //         delegationName: '中国',
        //         delegationLogo: '',
        //       },
        //     ],
        //     disciplineName: '艺术体操',
        //     disciplineId: 'GRY',
        //     matchStatus: 'Played',
        //     matchTime: '12:30',
        //     venueName: '场馆名称场馆名称1',
        //     homeName: '主队',
        //     homeLogo: '',
        //     homeScore: 3,
        //     awayName: '客队',
        //     awayLogo: '',
        //     awayScore: 2,
        //   },
        // ]
      },
    },
    detailPathName: {
      type: String,
      default: '',
    },
    chooseState: {
      type: String,
      default: 'default', //['default', 'choose', 'none'] none：没有鼠标经过效果
    },
    localStorageName: {
      type: String,
      default: '',
    },
    localStorageSaveDate: {
      //字段在该组件无用
      type: String,
      default: '',
    },
    themeClass: {
      // 不同页面视图的展示
      type: String,
      default: '',
    },
    viewMode: {
      // 相同页面，控制不同视图的展示
      type: String,
      default: '',
    },
  },
  data() {
    return {
      sportsTypeArr: ['combat', 'uncombat'],
      matchStatusObj: {
        CANCELLED: 3,
        DELAYED: 3,
        FINISHED: 2,
        GETTING_READY: 0,
        INTERRUPTED: 3,
        POSTPONED: 3,
        RESCHEDULED: 3,
        RUNNING: 1,
        SCHEDULED: 0,
        SCHEDULED_BREAK: 1,
        UNSCHEDULED: 2,
      },
      matchStatusColorArr: [
        {
          colorClass: 'unstart',
          key: ['GETTING_READY', 'SCHEDULED'],
          name: ['已就绪', '按日程计划'],
        },
        {
          colorClass: 'playing',
          key: ['RUNNING', 'SCHEDULED_BREAK'],
          name: ['比赛中', '中场休息'],
        },
        {
          colorClass: 'finished',
          key: ['FINISHED', 'UNSCHEDULED'],
          name: ['已结束', '未安排'],
        },
        {
          colorClass: 'other',
          key: [
            'CANCELLED',
            'DELAYED',
            'INTERRUPTED',
            'POSTPONED',
            'RESCHEDULED',
          ],
          name: ['已取消', '延误', '中断', '推迟', '改期'],
        },
      ],
    }
    // CANCELLED 已取消
    // DELAYED 延误
    // FINISHED 已结束
    // GETTING_READY 已就绪
    // INTERRUPTED 中断
    // POSTPONED 推迟
    // RESCHEDULED 改期
    // RUNNING 比赛中
    // SCHEDULED 按日程计划
    // SCHEDULED_BREAK 中场休息
    // UNSCHEDULED 未安排
  },
  methods: {
    matchStatusToMatchCN(matchStatus) {
      let index = this.matchStatusObj[matchStatus]
      let item = this.matchStatusColorArr[index]
      let matchCN = item.name[item.key.indexOf(matchStatus)]
      return this._valPerFormatHandler(matchCN)
    },
    goDetail(item) {
      console.debug(
        'goDetail:',
        item,
        this.openNewWeb,
        this.localStorageName,
        this.$dynamicConfig,
        this.detailPathName
      )
      if (this.chooseState === 'choose' && this.localStorageName) {
        let chooseObj = this.$localStorage.getItem(this.localStorageName)
          ? JSON.parse(this.$localStorage.getItem(this.localStorageName))
          : {
              cid: this.currCid,
              sid: this.currSid ? this.currSid : '',
              // date: this.localStorageSaveDate,
              chooseItemArr: [],
              chooseIdArr: [],
            }
        if (chooseObj.cid === this.currCid) {
          if (chooseObj.chooseItemArr.length === 0) {
            let newItem = JSON.parse(JSON.stringify(item))
            newItem.isChooseFlag = true
            chooseObj.chooseItemArr.push(newItem)
            chooseObj.chooseIdArr.push(item.chooseId)
          } else {
            let chooseItemArr = []
            let chooseIdArr = []
            chooseObj.chooseItemArr.forEach((chooseItem) => {
              if (chooseItem.chooseId !== item.chooseId) {
                chooseItemArr.push(chooseItem)
                chooseIdArr.push(chooseItem.chooseId)
              }
            })
            if (chooseItemArr.length === chooseObj.chooseItemArr.length) {
              let newItem = JSON.parse(JSON.stringify(item))
              newItem.isChooseFlag = true
              chooseItemArr.push(newItem)
              chooseIdArr.push(item.chooseId)
            }
            chooseObj.chooseItemArr = chooseItemArr
            chooseObj.chooseIdArr = chooseIdArr
          }
          this.$localStorage.setItem(
            this.localStorageName,
            JSON.stringify(chooseObj)
          )
          this.$emit('changeChooseNumEvent', {
            localStorageName: this.localStorageName,
            val: chooseObj.chooseIdArr.length,
            init: false,
          })
          console.debug('chooseObj:', chooseObj)
        } else {
          console.error('错误：赛事不同')
        }
      } else if (this.detailPathName) {
        let currSportsDetail = {
          sportsId: item.sportsId,
          eventId: item.eventId,
          matchId: item.matchId,
          sportsName: item.sportsName,
          eventName: item.eventName,
          // matchDetail: item
        }
        console.debug('sportsDetail_compreScore:', currSportsDetail)
        this.$localStorage.setItem(
          'mixtmt_platfromV4_currSportsDetail',
          JSON.stringify(currSportsDetail)
        )
        let params = {
          cid: this.currCid,
          sid: this.currSid,
          sportsId: item.sportsId,
          eventId: item.eventId,
          mid: item.matchId,
        }
        console.debug('this.detailPathName:', this.detailPathName)
        this.openNewWeb(
          this.$router,
          `${this.detailPathName}_${this.currCid}`,
          params
        )
      }
    },
    _valPerFormatHandler(val, ceil) {
      let data
      if (val === undefined || val === null || val === '' || val === ' ') {
        return '-'
      }
      data = `${val}${ceil ? ceil : ''}`
      return data
    },
  },
}
</script>

<style lang="scss" scoped>
.mixtmt_pc,
.mixtmt_ipad {
  .schedule_match_list {
    width: 100%;
    height: auto;
    &.onlyDisplay .match_list_item {
      .item_matchLeft {
        display: flex;
        display: -webkit-flex;
        justify-content: flex-start;
        align-items: center;
        width: 42.53vw;
        .matchLeft_colum1 {
          width: calc(100% - 30.3vw);
        }
        .matchLeft_colum2 {
          width: 30.3vw;
        }
      }
      .item_matchCenter {
        width: 19.75vw;
      }
    }
    .match_list_item {
      position: relative;
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: flex-start;
      height: auto;
      width: 100%;
      padding: 0.694vw 1.388vw;
      color: var(--mixtmt_greyColor3);
      border-bottom: 1px solid var(--mixtmt_greyColor5);
      transition: padding 0.3s linear;
      &.choose {
        padding: 0.694vw 1.388vw 0.694vw 2.776vw;
        .item_absChoose {
          width: 2.776vw;
          display: flex;
          display: -webkit-flex;
          justify-content: center;
          align-items: center;
          .checkbox_item {
            width: 1.388vw;
            height: 1.388vw;
            border-radius: 0.208vw;
            border: 1px solid var(--mixtmt_subColor1_1);
            display: flex;
            display: -webkit-flex;
            justify-content: center;
            align-items: center;
            background-color: var(--mixtmt_whiteColor);
            /* &.act {
                  background-color: var(--mixtmt_subColor1_1);
                  color: var(--mixtmt_whiteColor);
                } */
            svg {
              opacity: 0;
              fill: var(--mixtmt_whiteColor);
              transition: all 0.3s linear;
            }
          }
        }
        &.chooseAct {
          .checkbox_item {
            background-color: var(--mixtmt_subColor1_1);
            svg {
              opacity: 1;
            }
          }
        }
      }
      .matchLeft_colum1,
      .matchLeft_colum2,
      .matchCenter_colum1,
      .matchCenter_colum2 {
        display: flex;
        display: -webkit-flex;
        justify-content: space-between;
        align-items: flex-start;
        flex-direction: column;
        height: auto;
      }
      .matchLeft_colum1_row1,
      .matchLeft_colum2_row1,
      .matchCenter_colum1_row,
      .matchCenter_colum2_row {
        margin-bottom: 0.347vw;
      }
      .item_matchLeft {
        display: flex;
        display: -webkit-flex;
        justify-content: flex-start;
        align-items: center;
        width: 41.53vw;
        .matchLeft_colum1 {
          width: calc(100% - 32.3vw);
          .matchLeft_colum1_row1 {
            width: 100%;
            font-size: 1.388vw;
            line-height: 2.083vw;
            height: 2.083vw;
            font-weight: bold;
          }
          .matchLeft_colum1_row2 {
            display: flex;
            display: -webkit-flex;
            justify-content: flex-start;
            align-items: center;
            width: 100%;
            height: 2.083vw;
            .national_icon {
              padding-right: 0.694vw;
              width: 2.083vw;
              height: 0.903vw;
              overflow: hidden;
              background-image: var(--mixtmt_china_square_icon);
              background-size: auto 100%;
              background-repeat: no-repeat;
              background-position: left center;
            }
            .medal_icon {
              padding-right: 0.694vw;
              width: 1.805vw;
              height: 1.11vw;
              overflow: hidden;
              background-image: var(--mixtmt_medal_gold_icon);
              background-size: auto 100%;
              background-repeat: no-repeat;
              background-position: left center;
            }
          }
        }
        .matchLeft_colum2 {
          width: 32.3vw;
          .matchLeft_colum2_row1 {
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-size: 1.38vw;
            line-height: 2.083vw;
            height: 2.083vw;
            font-weight: bold;
          }
          .matchLeft_colum2_row2 {
            display: flex;
            display: -webkit-flex;
            justify-content: flex-start;
            align-items: center;
            width: 100%;
            height: 2.083vw;
            .sportHall_icon {
              width: 1.11vw;
              height: 1.11vw;
              background-image: var(--mixtmt_scheduleMatchList_sportHall_icon);
              background-size: 100% auto;
              background-position: 0 0;
              background-repeat: no-repeat;
            }
            .sportHall_name {
              width: calc(100% - 1.11vw);
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              font-size: 1.11vw;
              line-height: 2.083vw;
              padding: 0 0.486vw;
              color: var(--mixtmt_greyColor2);
            }
          }
        }
      }
      .item_matchCenter {
        display: flex;
        display: -webkit-flex;
        justify-content: space-between;
        align-items: center;
        width: 20.75vw;
        .matchCenter_colum1 {
          width: 15.98vw;
          .matchCenter_colum1_row {
            width: 100%;
            height: 2.083vw;
            display: flex;
            display: -webkit-flex;
            justify-content: flex-start;
            align-items: center;
            .delegationLogo {
              width: 1.38vw;
              height: 1.18vw;
              overflow: hidden;
              img {
                width: 100%;
                height: 100%;
                object-fit: contain;
                display: block;
              }
            }
            .delegationName {
              width: calc(100% - 1.38vw);
              padding-left: 0.972vw;
              font-size: 0.972vw;
              font-weight: bold;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
        }
        .matchCenter_colum2 {
          width: calc(100% - 15.98vw);
          padding-left: 0.694vw;
          .matchCenter_colum2_row {
            width: 100%;
            height: 2.083vw;
            font-size: 0.972vw;
            line-height: 2.083vw;
            font-weight: bold;
            text-align: left;
            padding-right: 0.347vw;
          }
        }
        &.uncombat {
          .matchCenter_colum2_row {
            display: flex;
            display: -webkit-flex;
            justify-content: flex-start;
            align-items: center;
            padding-right: 0;
            .medalIcon {
              width: 1.11vw;
              height: 1.11vw;
              overflow: hidden;
              background-size: auto 100%;
              background-repeat: no-repeat;
              background-position: left center;
              &.ME_GOLD {
                background-image: var(--mixtmt_medal_gold_icon);
              }
              &.ME_SILVER {
                background-image: var(--mixtmt_medal_silver_icon);
              }
              &.ME_BRONZE {
                background-image: var(--mixtmt_medal_bronze_icon);
              }
            }
          }
        }
      }
      .item_matchRight {
        position: absolute;
        right: 1.388vw;
        top: 50%;
        z-index: 10;
        transform: translateY(-50%);
        width: 6.94vw;
        display: flex;
        display: -webkit-flex;
        justify-content: flex-end;
        align-items: center;
        .matchRight_status {
          width: 6.94vw;
          height: 2.083vw;
          line-height: 2.083vw;
          font-size: 0.972vw;
          text-align: center;
          border-radius: 0.278vw;
          &.unstart {
            color: var(--mixtmt_subColor3_1);
            border: 1px solid var(--mixtmt_subColor3_1);
          }
          &.playing {
            color: var(--mixtmt_subColor5_1);
            border: 1px solid var(--mixtmt_subColor5_1);
          }
          &.finished {
            color: var(--mixtmt_greyColor2);
            border: 1px solid var(--mixtmt_greyColor2);
          }
          &.other {
            color: var(--mixtmt_subColor1_1);
            border: 1px solid var(--mixtmt_subColor1_1);
          }
        }
      }
      .item_absChoose {
        position: absolute;
        left: 0;
        top: 0;
        z-index: 2;
        width: 0;
        height: 100%;
        transition: width 0.3s linear;
      }
    }
  }
}

.mixtmt_pc {
  .schedule_match_list {
    .match_list_item:not(.none) {
      &:hover,
      &.choose.chooseAct {
        background-color: var(--mixtmt_mainColor);
        color: var(--mixtmt_whiteColor);
        /* .item_matchCenter {
        } */
        .item_matchRight {
          .matchRight_status.unstart {
            color: var(--mixtmt_whiteColor);
            background-color: var(--mixtmt_subColor3_1);
            border: 1px solid var(--mixtmt_subColor3_1);
          }
          .matchRight_status.playing {
            color: var(--mixtmt_whiteColor);
            background-color: var(--mixtmt_subColor5_1);
            border: 1px solid var(--mixtmt_subColor5_1);
          }
          .matchRight_status.finished {
            opacity: 0.45;
            color: var(--mixtmt_mainColor);
            background-color: var(--mixtmt_whiteColor);
            border: 1px solid var(--mixtmt_whiteColor);
          }
          .matchRight_status.other {
            color: var(--mixtmt_whiteColor);
            background-color: var(--mixtmt_subColor1_1);
            border: 1px solid var(--mixtmt_subColor1_1);
          }
        }
        .item_matchLeft {
          .matchLeft_colum2 {
            .matchLeft_colum2_row2 {
              .sportHall_name {
                color: var(--mixtmt_whiteColor);
              }
            }
          }
        }
      }
      &.choose.chooseAct,
      &.choose,
      &.default {
        cursor: pointer;
      }
    }
  }
}
</style>
